export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'ae1b7f7b-385e-4769-a2ff-af8ad78a9e3c';
export const MODAL_CLOSE_SEC = 2.5;
